import {KTSVG} from '../../../../../../_metronic/helpers'
import React from 'react'
import {Link} from 'react-router-dom'
import {useIntl} from 'react-intl'


const Table: React.FC = () => {
  

  const intl = useIntl()
  

  return (
    <div className='card shadow p-3 mb-2 bg-white rounded'>
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          {intl.formatMessage({id: 'CLOUDCATEGORY.TITLE'})}
          <span className='text-muted mt-1 fw-bold fs-7'></span>
        </h3>
        <div
          className='card-toolbar'
          data-bs-toggle='tooltip'
          data-bs-placement='top'
          data-bs-trigger='hover'
          title='Click to add a user'
        >
          <Link to='/addcloudcategory' className='btn btn-sm btn-light-primary'>
            <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
            {intl.formatMessage({id: 'CLOUDCATEGORY.ADD_BUTTON'})}
          </Link>
        </div>
      </div>

      {/* begin::Body */}
      <div className='card-body py-1'>
        {/* begin::Table container */}
        <div className='table-responsive'>
          {/* begin::Table */}
          <table
            className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'
            id={'datatables'}
          >
            {/* begin::Table head */}
            <thead>
              <tr>
                <th className='min-w-200px'>{intl.formatMessage({id: 'COMMON.INPUT_NAME'})}</th>
                <th className='min-w-200px'>
                  {intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
                </th>
                {/* <th className='min-w-160px'>Apelido</th> */}
              </tr>
            </thead>
            {/* end::Table head */}
          </table>
        </div>
      </div>
    </div>
  )
}

export {Table}
